import { BlindsOpenIcon } from './BlindsOpenIcon';

/**
 * author: idevo89
 * id 5DCCF3FA-F418-4052-9B93-6FA85C2659F5
 * name blinds-open
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blinds-open.svg
 * tags
 * - Home Automation 
 */
export const RollerShadeOpenIcon = BlindsOpenIcon;
export default RollerShadeOpenIcon